import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';

import { IRouteItem } from '@ib-core/interfaces/route-item.intf';
import { AbstractBaseComponent } from '@ib-shared/abstract/abstract-base';
import { filter, takeUntil } from 'rxjs';

interface IBreadcrumb {
  title: string;
  path: Array<string>;
}

@Component({
  selector: 'ib-breadcrumbs',
  templateUrl: './breadcrumbs.component.html',
  styleUrls: ['./breadcrumbs.component.scss'],
})
export class BreadcrumbsComponent
  extends AbstractBaseComponent
  implements OnInit, OnDestroy
{
  public items: Array<IBreadcrumb>;
  constructor(private actRoute: ActivatedRoute, private router: Router) {
    super();
  }

  ngOnInit(): void {
    this.initBreadcrumbs();
    this.router.events
      .pipe(
        filter(event => event instanceof NavigationEnd),
        takeUntil(this.destroy$),
      )
      .subscribe(() => {
        this.initBreadcrumbs();
      });
  }

  ngOnDestroy(): void {
    super.destroySubscriptions();
  }

  private initBreadcrumbs(): void {
    this.items = this.createBreadcrumbs(this.actRoute.root);
  }

  private createBreadcrumbs(
    route: ActivatedRoute,
    url: Array<string> = ['/'],
    breadcrumbs: Array<IBreadcrumb> = [],
  ): Array<IBreadcrumb> {
    const children: Array<ActivatedRoute> = route.children;

    if (children.length === 0) {
      return breadcrumbs;
    }

    for (const child of children) {
      const routeURL: string = child.snapshot.url
        .map(segment => segment.path)
        .join('/');
      if (routeURL !== '') {
        url.push(routeURL);
      }
      const data: IRouteItem = child.snapshot.data
        ? (child.snapshot.data as IRouteItem)
        : null;
      if (data?.useInBreadcrumbs && data.title) {
        const b: IBreadcrumb = {
          title: data.title,
          path: url,
        };
        if (!breadcrumbs.find(i => JSON.stringify(i) === JSON.stringify(b)))
          breadcrumbs.push(b);
      }
      return this.createBreadcrumbs(child, url, breadcrumbs);
    }
  }
}
